/** @format */

interface CardKpis {
  kpiIds: string[];
}

export const getKpiFilterOptions = (cards: ReadonlyArray<CardKpis>): string[] => {
  const set = new Set<string>();
  cards.forEach(card => card.kpiIds.forEach(id => set.add(id)));
  return [...set];
};
